import { PureComponent, PropsWithChildren } from "react";

export default class CollapsibleHeading extends PureComponent<PropsWithChildren> {
  render() {
    return (
      <div className="ddbc-collapsible__heading">{this.props.children}</div>
    );
  }
}
